import React, { Fragment, useState } from "react";
import { ToggleButton } from "../Utils/common";

export default function VenuePlans() {
  const [selectedView, setSelectedView] = useState(false);
  return (
    <Fragment>
      <div className="d-flex justify-content-center">
        <div className={`${window.innerWidth > 990 ? "w-75" : "w-100"} mt-3`}>
          <div className="float-right">
            <ToggleButton isOn={selectedView} setIsOn={setSelectedView} />
          </div>
          <table class="table table-striped table-bordered plansTable">
            <thead>
              <tr>
                <th scope="col">Plan details</th>
                {/* <th scope="col" className="text-center">
                  Free Plan
                </th> */}
                <th scope="col" className="text-center">
                  Basic Plan <br />
                  <button>
                    Rs {!selectedView ? "1099/ Month" : "11200/ Year"}
                  </button>
                </th>
                <th scope="col" className="text-center">
                  Pro Plan <br />
                  <button>
                    Rs {!selectedView ? "1999/ Month" : "20389/ Year"}
                  </button>
                </th>
                <th scope="col" className="text-center">
                  Commission <br />
                  {/* <button>10%/ Booking</button> */}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>2 Default Views</th>
                {/* <td>
                  <img src="/images/PlanTick.svg" alt="" />
                </td> */}
                <td>
                  <img src="/images/PlanTick.svg" alt="" />
                </td>
                <td>
                  <img src="/images/PlanTick.svg" alt="" />
                </td>
                <td>
                  <img src="/images/PlanTick.svg" alt="" />
                </td>
              </tr>
              <tr>
                <th>Dashboard Access</th>
                {/* <td>
                  <img src="/images/PlanTick.svg" alt="" />
                </td> */}
                <td>
                  <img src="/images/PlanTick.svg" alt="" />
                </td>
                <td>
                  <img src="/images/PlanTick.svg" alt="" />
                </td>
                <td>
                  <img src="/images/PlanTick.svg" alt="" />
                </td>
              </tr>
              <tr>
                <th>1 Staff Member</th>
                {/* <td>
                  <img src="/images/PlanTick.svg" alt="" />
                </td> */}
                <td>
                  <img src="/images/PlanTick.svg" alt="" />
                </td>
                <td>
                  <img src="/images/PlanTick.svg" alt="" />
                </td>
                <td>
                  <img src="/images/PlanTick.svg" alt="" />
                </td>
              </tr>
              <tr>
                <th>Special Package Plan Offer</th>
                {/* <td>
                  <img src="/images/PlanTick.svg" alt="" />
                </td> */}
                <td>
                  <img src="/images/PlanTick.svg" alt="" />
                </td>
                <td>
                  <img src="/images/PlanTick.svg" alt="" />
                </td>
                <td>
                  <img src="/images/PlanTick.svg" alt="" />
                </td>
              </tr>
              <tr>
                <th>WhatsApp Notifications</th>
                {/* <td>
                  <img src="/images/PlanTick.svg" alt="" />
                </td> */}
                <td>
                  <img src="/images/PlanCross.svg" alt="" />
                </td>
                <td>
                  <img src="/images/PlanTick.svg" alt="" />
                </td>
                <td>
                  <img src="/images/PlanTick.svg" alt="" />
                </td>
              </tr>
              <tr>
                <th>Easy Slot Booking View</th>
                {/* <td>
                  <img src="/images/PlanTick.svg" alt="" />
                </td> */}
                <td>
                  <img src="/images/PlanCross.svg" alt="" />
                </td>
                <td>
                  <img src="/images/PlanTick.svg" alt="" />
                </td>
                <td>
                  <img src="/images/PlanTick.svg" alt="" />
                </td>
              </tr>
              <tr>
                <th>Unlimited Staff Members</th>
                {/* <td>
                  <img src="/images/PlanTick.svg" alt="" />
                </td> */}
                <td>
                  <img src="/images/PlanCross.svg" alt="" />
                </td>
                <td>
                  <img src="/images/PlanTick.svg" alt="" />
                </td>
                <td>
                  <img src="/images/PlanTick.svg" alt="" />
                </td>
              </tr>
              <tr>
                <th> Promoted Listing</th>
                {/* <td>
                  <img src="/images/PlanCross.svg" alt="" />
                </td> */}
                <td>
                  <img src="/images/PlanCross.svg" alt="" />
                </td>
                <td>
                  <img src="/images/PlanTick.svg" alt="" />
                </td>
                <td>
                  <img src="/images/PlanCross.svg" alt="" />
                </td>
              </tr>
              <tr>
                <th> 1 Instagram Reel Collab & Post (1 per quarter)</th>
                {/* <td>
                  <img src="/images/PlanCross.svg" alt="" />
                </td> */}
                <td>
                  <img src="/images/PlanCross.svg" alt="" />
                </td>
                <td>
                  <img src="/images/PlanTick.svg" alt="" />
                </td>
                <td>
                  <img src="/images/PlanCross.svg" alt="" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </Fragment>
  );
}
